import { render, staticRenderFns } from "./routerGuide.vue?vue&type=template&id=acb50730&"
import script from "./routerGuide.vue?vue&type=script&lang=js&"
export * from "./routerGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports